const mixGroupProduct = {
    data() {
        return {
            group_product: [],
            group_product_price_rules:[]
        }
    },
    mounted() {
        if (this.add_group_products) {
            this.$axios.get(`/api/store/products/${this.product.ID}/group-products`).then(res => {
                let { price_rules = [], products = [] } = res.data
                if (products.length) {
                    this.group_product = products;
                };
                if(this.mainProduct) {
                    this.group_product = [this.mainProduct,...this.group_product]
                }
                if(price_rules.length){
                    this.group_product_price_rules = price_rules;
                }
            })
        }

    }
}
export default mixGroupProduct;
